// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f0c4e1b5","234":"9867bd9a","359":"b5a455bd","361":"39e56eee"}[chunkId] + ".chunk.js";
};